/* SADU site skin — tiny runtime for every page (loaded after sadu-lang.js).
   1) Dawn product/collection/article cards reveal on scroll (opt-in class .sl-reveal, handled by sadu-lang.js)
   2) Gold ring on the card the finger rests on (phones have no hover)
   3) Marks the <html> with .sadu-site so the CSS can scope enhancements that need JS */
(function () {
  if (window.__saduSite) return; window.__saduSite = true;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hover = matchMedia('(hover: hover)').matches;
  document.documentElement.classList.add('sadu-site');

  function prep(root) {
    var cards = (root || document).querySelectorAll('.card-wrapper:not(.sl-reveal), .article-card:not(.sl-reveal), .collection-list__item:not(.sl-reveal)');
    cards.forEach(function (c, i) { if (!reduce) { c.classList.add('sl-reveal'); c.style.setProperty('--i', String(i % 6)); } });
    if (window.SL && SL.reveal) SL.reveal(root || document);
  }
  function touchRing() {
    if (hover || !('IntersectionObserver' in window)) return;
    var live = null;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting && e.intersectionRatio >= 0.85) { if (live && live !== e.target) live.classList.remove('is-live'); live = e.target; live.classList.add('is-live'); }
        else if (e.target === live && !e.isIntersecting) { live.classList.remove('is-live'); live = null; }
      });
    }, { threshold: [0.85] });
    document.querySelectorAll('.card-wrapper').forEach(function (c) { io.observe(c); });
  }
  function headerH(){ var h=document.querySelector(".header-wrapper"); if(h) document.documentElement.style.setProperty("--sadu-header-h", h.getBoundingClientRect().height+"px"); }
  function start() { prep(); touchRing(); headerH(); window.addEventListener("resize", headerH, { passive: true }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else setTimeout(start, 0);
  /* Dawn re-renders the product grid on facet changes / pagination via fetch: re-prep the new cards */
  var mo = ('MutationObserver' in window) ? new MutationObserver(function (m) { var hit = false; m.forEach(function (x) { if (x.addedNodes && x.addedNodes.length) hit = true; }); if (hit) { clearTimeout(mo._t); mo._t = setTimeout(function () { prep(document.getElementById('ProductGridContainer') || document); }, 80); } }) : null;
  var grid = document.getElementById('ProductGridContainer');
  if (mo && grid) mo.observe(grid, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', function (e) { prep(e.target); });
})();
